/**
 * Signup wizard step identifiers.
 *
 * Lives in its own tiny module so the routes file (and anyone else that just
 * needs the constant) can `import { ViewSignupPages }` without pulling
 * `ViewSignup.jsx` — and therefore wagmi / @reown / @lifi — into their chunk.
 */
export const ViewSignupPages = {
  register: 'register',
  set_username: 'set_username',
  setting_up_account: 'setting_up_account',
  email_confirmation_pending: 'email_confirmation_pending',
  email_confirmed: 'email_confirmed',
}
